var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.4,1.5c.5,0,1,0,1.5,0,.2,0,.5,0,.7,0,2.4.4,4.4,1.4,6,3.1,1.5,1.5,2.4,3.3,2.8,5.4,0,.4.1.7.2,1.1v1.5c0,0,0,.1,0,.2,0,.4,0,.8-.2,1.3-1,4.7-5.2,8.2-10,8.3-1.8,0-3.5-.4-5.1-1.2,0,0-.2,0-.3,0-1.2.3-2.3.6-3.5.9-.6.2-1.2.3-1.8.5,0,0,0,0,0,0,0,0,0,0,0-.1.5-1.7.9-3.4,1.4-5.1,0-.1,0-.2,0-.3-1-1.9-1.5-3.9-1.2-6.1.2-2,.9-3.8,2.2-5.4,1.7-2.1,3.9-3.3,6.5-3.8.4,0,.7-.1,1.1-.2ZM3,20c0,0,.1,0,.2,0,1-.3,1.9-.5,2.9-.8.1,0,.3,0,.4,0,2.3,1.4,4.8,1.7,7.3.8,3.4-1.1,5.8-4.2,6-7.7.1-2.2-.5-4.2-1.9-5.9-2.2-2.6-5-3.7-8.4-3.2-2.1.3-3.9,1.4-5.2,3.1-1.4,1.8-2.1,3.9-1.9,6.2.1,1.4.6,2.8,1.4,4,0,.1.1.3,0,.5-.3,1-.5,1.9-.8,2.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.8,16.9c-.6,0-1.2-.2-1.7-.4-2-.6-3.5-1.9-4.8-3.5-.6-.7-1.1-1.4-1.4-2.2-.5-1.3-.2-2.4.7-3.4.2-.2.5-.3.8-.3.2,0,.4,0,.6,0,.2,0,.3.2.4.4.2.5.4,1,.6,1.5,0,.2.2.4.2.5,0,.2,0,.3,0,.5-.2.3-.4.6-.6.8-.2.3-.2.4,0,.7.8,1.4,2,2.4,3.5,3,.3.1.4.1.7-.2.2-.3.5-.6.7-.9.2-.2.3-.3.6-.2,0,0,0,0,.1,0,.7.3,1.3.6,2,.9.2,0,.3.2.3.4,0,.8-.3,1.4-1,1.8-.5.3-1,.5-1.6.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.ef0dd152900c4d0d74568386ec2d56bb.svg";
export { ForwardRef as ReactComponent };